import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BootstrapCompetitionsInfoComponent } from './components/bootstrap-competitions-info/bootstrap-competitions-info.component';


const routes: Routes = [{
  path:'', component:BootstrapCompetitionsInfoComponent
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CompetitionEventInfoRoutingModule { }
